// Note, this wrapper is taken from the @nova/react library.  The use of the wrapper directly in @nova/react will cause
// webpack to inadvertently dead code remove the @graphitation implementation of the tag, so we're instead directly
// calling into the @graphitation library in our code.
import { __read, __spreadArray } from "tslib";
import { graphql as graphqlJsTag } from '@graphitation/graphql-js-tag';
/**
 * This tagged template function is used to capture a single GraphQL document, such as an operation or a fragment. When
 * a document refers to fragments, those should be interpolated as trailing components, but *no* other interpolation is
 * allowed. Put differently, the documents themselves should be entirely static, which allows for static optimizations.
 *
 */
export function graphql(document) {
    var fragments = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        fragments[_i - 1] = arguments[_i];
    }
    return graphqlJsTag.apply(void 0, __spreadArray([document], __read(fragments), false));
}
//# sourceMappingURL=taggedNode.js.map